__turbopack_context__.v({
  "back_button": "ZVZ74q_back_button",
  "expat_btn": "ZVZ74q_expat_btn",
  "icon_btn": "ZVZ74q_icon_btn",
});
